import axios from '../plugins/axios'

const createDocumentPlanTemplate = planTemplate => axios.post('/document/plan/template', planTemplate)
const updateDocumentPlan = plan => axios.put('/document/plan/template', plan)
const getAllTemplatesDocumentPlan = () => axios.get('/document/plan/all/templates')
const assignDocumentPlanCompany = planCompany => axios.post('/document/plan/company', planCompany)
const saveDocumentReport = reportDocument => axios.post('/document/report', reportDocument)
const getDocuments = (filters) => axios.get('/document/all', { params: filters })
const getDocumentById = id => axios.get(`/document/${id}`)
const updateDocuments = ReportDocument => axios.put('/document/report', ReportDocument)
const deleteDocument = id => axios.delete('/document', { data: { id } })

export {
  createDocumentPlanTemplate,
  updateDocumentPlan,
  getAllTemplatesDocumentPlan,
  assignDocumentPlanCompany,
  saveDocumentReport,
  getDocuments,
  getDocumentById,
  updateDocuments,
  deleteDocument
}
